module.exports = __webpack_public_path__ + "static/zuri-5aa6cb2640decb20d36b2f2ec3c57f5f.png";